/**
 * "Do uzupełnienia" (owner 2026-10-19 22:55): a small orange dot (token `--todo`, rule 2 of docs/wyglad.md) next to an
 * item that lacks one of the completeness fields, and next to each such empty field's label in the form. The server
 * sends `missingFields` counted from the fields the user may see only.
 */
export const COMPLETENESS_LABELS: Record<string, string> = {
  purchasePriceGrosze: 'cena zakupu',
  valueGrosze: 'wartość sprzętu',
  rentalFactorBp: 'współczynnik wynajmu',
  rentalPriceDayGrosze: 'docelowa cena wynajmu',
  defaultLocationId: 'domyślna lokalizacja',
};
const ORDER = Object.keys(COMPLETENESS_LABELS);

/** "Brakuje: cena zakupu, domyślna lokalizacja". */
export function missingText(missing: readonly string[]): string {
  return `Brakuje: ${ORDER.filter((f) => missing.includes(f)).map((f) => COMPLETENESS_LABELS[f]).join(', ')}`;
}

/** The dot of a list row or the item card: hover or keyboard focus shows what is missing. */
export function TodoDot({ missing }: { missing: readonly string[] | undefined }) {
  if (!missing || missing.length === 0) return null;
  const text = missingText(missing);
  return <span className="todo-dot tip" role="img" tabIndex={0} aria-label={`Do uzupełnienia. ${text}`} data-tip={text} />;
}

/** The dot next to an empty field's label in the form: gone as soon as the field is filled. */
export function FieldTodoDot({ empty }: { empty: boolean }) {
  return empty ? <span className="todo-dot field-dot" role="img" aria-label="do uzupełnienia" /> : null;
}
